var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout-padding" },
    [
      _c(
        "q-tabs",
        {
          ref: "tabs",
          staticClass: "settings-tabs round-borders no-scroll",
          attrs: { color: "white", "underline-color": "primary" },
          model: {
            value: _vm.selectedTab,
            callback: function($$v) {
              _vm.selectedTab = $$v
            },
            expression: "selectedTab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "general",
              default: "",
              label: _vm.$t("general"),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "contact-data",
              label: _vm.$t("contact_data"),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "invoicing",
              label: _vm.$t("invoicing"),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "payments",
              label: _vm.$tc("payment", 2),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "customers",
              label: _vm.$t("customers"),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "members",
              label: _vm.$tc("member", 2),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "tax-advisor",
              label: _vm.$t("tax_advisor"),
              color: "black"
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "subscription",
              label: _vm.$t("subscription"),
              color: "black"
            },
            slot: "title"
          }),
          _vm.user.isOwnerOf(_vm.team)
            ? _c("q-tab", {
                attrs: {
                  slot: "title",
                  name: "danger-zone",
                  label: _vm.$t("danger_zone"),
                  color: "black"
                },
                slot: "title"
              })
            : _vm._e(),
          _c("general-settings"),
          _c("contact-data"),
          _c("invoice-settings"),
          _c("payment-settings"),
          _c("customer-settings"),
          _c("member-settings"),
          _c("tax-advisor-settings"),
          _c("subscription-settings"),
          _c("danger-zone-settings")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }